import React, { createContext, useContext, useState, useEffect } from 'react';

const OrientationContext = createContext();

export const OrientationProvider = ({ children }) => {
  const [isPortrait, setIsPortrait] = useState(window.innerWidth < window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <OrientationContext.Provider value={{ isPortrait }}>
      {children}
    </OrientationContext.Provider>
  );
};

export const useOrientation = () => {
  const context = useContext(OrientationContext);
  if (!context) {
    throw new Error('useOrientation must be used within an OrientationProvider');
  }
  return context;
}; 